/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'stellar_body/defense': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M10.018 5.869l-.862.61 6.72 6.318-13.28-1.661-1.369.97 17.546 2.025z"/><path pid="1" d="M12.46 11.191L8.184 7.17l-4.176 2.963z"/>'
  }
})
